module.exports = __webpack_public_path__ + "img/shutong.7f3835eb.png";